import debug from 'debug';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';
import MultiViewsOverlay from 'Minetilbud/Shared/Components/overlay/multi-views-overlay';
import OverlayBehaviour from 'Minetilbud/Shared/Components/overlay/behaviour';
import LoginForm from './render/login-form';

const log = debug('UserLogin');

class UserLogin extends BaseComponent {
	constructor(element) {
		super(element);

		this.modalCloseEvent = this.modalCloseHandler.bind(this);
		this.overlayHideEvent = this.overlayHideHandler.bind(this);
		this.showLoginEvent = this.showLoginHandler.bind(this);

		this.initialize();
	}

	eventListeners() {
		this.dom.link.addEventListener('click', this.showLoginEvent, false);
		document.addEventListener(OverlayBehaviour.eventKeys.hide, this.overlayHideEvent, false);
		document.addEventListener(OverlayBehaviour.eventKeys.modalClose, this.modalCloseEvent, false);
	}

	getSettings() {
		this.settings = {
			redirectUrl: '/'
		};

		try {
			const settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
		}

		return true;
	}

	initialize() {
		this.getSettings();

		this.initDomCache();
		this.eventListeners();
	}

	/**
	 * @param {CustomEvent} event
	 */
	 modalCloseHandler({ detail: { options: { instanceId } } }) {
		if (instanceId !== this.instanceId) return;
		this.overlay.hide();
	}

	/**
	 * @param {CustomEvent} event
	 */
	overlayHideHandler({ detail: { options: { instanceId } } }) {
		if (instanceId !== this.instanceId) return;

		this.overlay.remove();
	}

	async showLoginHandler(event) {
		event.preventDefault();

		this.overlay = new MultiViewsOverlay();
		this.instanceId = this.overlay.getInstanceId();

		const loginForm = new LoginForm(this.instanceId, this.settings.redirectUrl);
		const loginFormDom = await loginForm.get();
		this.overlay.create(loginFormDom);

		loginForm.initialize();

		this.overlay.show(0);
	}

}

export default UserLogin;
